import { useParams } from "react-router-dom";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import logoCurp from "../../../assets/images/curp.png";
import { useAccesoEdificios } from "hooks/accesoEdificios.ts/useAccesoEdificios";
import TransgenderIcon from "@mui/icons-material/Transgender";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import moment from "moment";
import { base64ToImgURL } from "helpers/helpers";
import { useEffect } from "react";
export const FormDatosQR = () => {
  const { cveQr } = useParams();
  const { infoQr, startGetDatosQR } = useAccesoEdificios();
  useEffect(() => {
    if (cveQr) {
      startGetDatosQR(cveQr);
    }/* eslint-disable-next-line */
  }, [cveQr]);
  
  const isValid = infoQr?.vigente === "S";
  const typeImg = infoQr?.rutaIdentificacion?.split(".");
  if (!infoQr) {
    return (
      <Card
        sx={{
          borderRadius: "15px",
          height: "80vh",
          margin: "auto",
          backgroundColor: "white",
          overflow: "auto",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)", // Añade sombra
        }}
      >
        <CardHeader
          title="SIN QR ESCANEADO"
          sx={{
            backgroundColor: "gray",
            color: "white",
            textAlign: "center",
            padding: "16px",
          }}
        />
        <CardContent sx={{ color: "black", textAlign: "center" }}>
          <QrCodeScannerIcon fontSize="large" />
          <Typography variant="h6">
            <Divider />
            Para verificar tu código QR, por favor sigue estos pasos:
            <Divider />
            <ol>
              <li>
                1.- Haz clic en el botón 'Presiona Aquí para comenzar a
                escanear'.
              </li>
              <li>
                2.- Luego, utiliza tu escáner físico para escanear el código QR.
              </li>
              <li>
                3.- El proceso se realizará automáticamente una vez que escanees
                el código.
              </li>
              <li>
                4.- Después de escanear, podrás ver la información
                correspondiente.
              </li>
            </ol>
            <Divider />
            ¡Listo! Por favor, sigue estos pasos para continuar.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card
      sx={{
        borderRadius: "15px",
        height: "80vh",
        margin: "auto",
        border: isValid ? "2px solid green" : "2px solid #d20f17",
        backgroundColor: "white",
        overflow: "auto",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)", // Añade sombra
      }}
    >
      <CardHeader
        title={`CÓDIGO QR ${isValid ? "VÁLIDO" : "NO VÁLIDO"}`}
        sx={{
          backgroundColor: isValid ? "green" : "#d20f17",
          color: "white",
          textAlign: "center",
        }}
      />
      <CardContent sx={{ color: "black" }}>
          {isValid ? (
            <Grid container spacing={2}>
              <Grid item sm={12} md={6} lg={6}>
                <Divider />
                <Grid container alignItems="center" spacing={2}>
                  <Grid item>
                    <Avatar alt="User" />
                  </Grid>
                  <Grid item>
                    <Typography variant="h6">Nombre:</Typography>
                    {infoQr.nombreUsuario}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sm={12} md={6} lg={6}>
                <Divider />
                <Grid container alignItems="center" spacing={2}>
                  <Grid item>
                    <Avatar alt="Genero">
                      <TransgenderIcon />
                    </Avatar>
                  </Grid>
                  <Grid item>
                    <Typography variant="h6">Género:</Typography>
                    {infoQr.descTipoSexo}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sm={12} md={6} lg={6}>
                <Divider /> {/* Línea de separación */}
                <Grid container alignItems="center" spacing={2}>
                  <Grid item>
                    <Avatar
                      alt="curp"
                      src={logoCurp}
                      sx={{
                        borderRadius: "50%",
                        background: "#bdbdbd",
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <Typography variant="h6">CURP:</Typography>
                    {infoQr?.curp}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sm={12} md={6} lg={6}>
                <Divider /> {/* Línea de separación */}
                <Grid container alignItems="center" spacing={2}>
                  <Grid item>
                    <Avatar alt="calendario">
                      <CalendarMonthIcon />
                    </Avatar>
                  </Grid>
                  <Grid item>
                    <Typography variant="h6">Vigente hasta: </Typography>
                    {infoQr?.cveTipoVigencia === 1
                      ? infoQr?.descTipoVigencia
                      : moment(infoQr?.fechaVigencia).format("DD/MM/YYYY")}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  textAlign: "center",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <Divider />
                <Grid container alignItems="center">
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      textAlign: "center",
                      alignContent: "center",
                    }}
                  >
                    <Avatar alt="INE">
                      <AccountBoxIcon />
                    </Avatar>
                    <Typography variant="h6">INE:</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      textAlign: "center",
                      alignContent: "center",
                    }}
                  >
                    <Avatar alt="QR">
                      <AccountBoxIcon />
                    </Avatar>
                    <Typography variant="h6">QR:</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{
                      textAlign: "center",
                      alignContent: "center",
                      alignItems: "center",
                      marginTop: "1rem",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <img
                          src={`${base64ToImgURL(
                            String(infoQr?.identificacion64),
                            String(typeImg?.[typeImg?.length - 1])
                          )}`}
                          alt="INE"
                          style={{
                            width: "100%",
                            height: "300px",
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <img
                          src={`${base64ToImgURL(
                            String(infoQr?.codigoQr64),
                            "image/svg+xml"
                          )}`}
                          alt="QR"
                          style={{
                            width: "100%",
                            height: "300px",
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <br />

                <Divider />
              </Grid>
              <Divider />
            </Grid>
          ) : (
            <Grid container>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item>
                  <QrCodeScannerIcon fontSize="large" />
                </Grid>
              </Grid>
              <Grid item>
                <Typography variant="h6">
                  Código QR no válido. Por favor, contacte al administrador del
                  sistema.
                </Typography>
              </Grid>
            </Grid>
          )}
      </CardContent>
    </Card>
  );
};
